/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import React, {createRef} from "react";
import autobind from "autobind-decorator";
import {FormControl} from "react-bootstrap";

export class TextFieldEditor extends BaseFieldEditor {

	constructor() {
		super();

		this.inputRef = createRef();
	}

	componentDidMount() {
		super.componentDidMount();

		if (this.isDefaultInput()) {
			this.inputRef?.focus?.();
			this.inputRef?.select?.();
		}
	}

	@autobind
	_render() {
		const {Value, OnUpdate, FieldDef} = this.props;

		return <FormControl
			ref={this.inputRef}
			type="text"
			value={Value || ""}
			onChange={x => OnUpdate(x.target.value)}
			placeholder={FieldDef.placeholder}
		/>;
	}
}